import React, { useState } from 'react'
import { useTheme } from '../../../../components/hooks/useTheme';
import useAuth from '../../../../components/hooks/useAuth';
import { Button, Dialog } from '@mui/material';
import axios from 'axios';
import baseURL from '../../../../configs/api';
import PleaseWaitPopup from '../../../PleaseWaitPopup';
import colorConfigs from '../../../../configs/colorConfigs';
import CustomFormatDatePicker from '../../../../components/common/CustomFormatDatePicker';
import moment from 'moment';
import useGeneral from '../../../../components/hooks/useGeneral';
import Cookies from 'js-cookie';
import useTenant from '../../../../components/hooks/useTenant';

type AddBlockedPeriodProps = {
    idNumber: any;
    openAddBlockedPeriod: boolean;
    setOpenAddBlockedPeriod: (value: boolean) => void;
    setRefreshBlockedPeriodList: (value: boolean) => void;
}

export const AddBlockedPeriod = ({ idNumber, openAddBlockedPeriod, setOpenAddBlockedPeriod, setRefreshBlockedPeriodList }: AddBlockedPeriodProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { dateFormat }: any = useGeneral();
    const [startDate, setStartDate] = useState<string>("");
    const [startTime, setStartTime] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [endTime, setEndTime] = useState<string>("");
    const [colorSelected, setColorSelected] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [pleaseWait, setPleaseWait] = useState<boolean>(false);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!pleaseWait) {
            setPleaseWait(true);
            axios
                .post(
                    `${baseURL}vehicleBlockPeriod?userId=${auth?.id}`,
                    JSON.stringify({
                        vehicleId: idNumber?.state,
                        startDate: moment(`${startDate}T${startTime}`).format('YYYY-MM-DDTHH:mm'),
                        endDate: moment(`${endDate}T${endTime}`).format('YYYY-MM-DDTHH:mm'),
                        description,
                        colorSelected,
                        createdAt: new Date().toLocaleString(),
                        createdBy: auth?.givenname,
                    }),
                    {
                        headers: {
                            'X-Tenant-ID': tenantId,
                            "Content-Type": "application/json" 
                        },
                        withCredentials: true,
                    }
                )
                .then(() => {
                    setPleaseWait(false);
                    setOpenAddBlockedPeriod(false);
                    setRefreshBlockedPeriodList(true);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWait(false);
                    handleTenantError(error);
                });
        }
    }

    return (
        <>
            <Dialog
                open={openAddBlockedPeriod}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '550px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[10px] py-[5px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>

                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Blocked Period</h2>

                                    <span className={`material-symbols-outlined text-[25px] font-light cursor-pointer ${themeStyles.main.textHeadingColor}`} onClick={() => setOpenAddBlockedPeriod(false)}>close</span>

                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="grid grid-cols-2 gap-6 mt-4">
                                        <div className="space-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Start Date</label>
                                                <CustomFormatDatePicker
                                                    value={startDate}
                                                    onChange={setStartDate}
                                                    dateFormat={dateFormat}
                                                    required={true}
                                                    minDate={new Date().toISOString().split("T")[0]}
                                                    maxDate={endDate ? new Date(endDate).toISOString().split("T")[0] : ""}
                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>End Date</label>
                                                <CustomFormatDatePicker
                                                    value={endDate}
                                                    onChange={setEndDate}
                                                    dateFormat={dateFormat}
                                                    required={true}
                                                    minDate={startDate ? new Date(startDate).toISOString().split("T")[0] : new Date().toISOString().split("T")[0]}
                                                />
                                            </div>
                                        </div>

                                        <div className="space-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Start Time</label>
                                                <input
                                                    type="time"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={startTime}
                                                    onChange={(e) => setStartTime(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>End Time</label>
                                                <input
                                                    type="time"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={endTime}
                                                    onChange={(e) => setEndTime(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="flex flex-col">
                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Color</label>
                                            <input
                                                type="color"
                                                name="colorSelected"
                                                style={{
                                                    fontSize: "14px",
                                                }}
                                                value={colorSelected}
                                                onChange={(e) => setColorSelected(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Description</label>
                                        <textarea
                                            className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            rows={6}
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                        />
                                    </div>



                                    <div className="mt-4 w-full flex gap-4">
                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.main.bg
                                            }}
                                            type="submit"
                                        >
                                            Save
                                        </Button>

                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.cancel.bg,
                                                border: colorConfigs.btn.cancel.border,
                                                color: colorConfigs.btn.cancel.color
                                            }}
                                            onClick={() => setOpenAddBlockedPeriod(false)}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <PleaseWaitPopup pleaseWaitPopup={pleaseWait} />
        </>
    )
}